import { render } from "./Footer.vue?vue&type=template&id=6f1e7192"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
script.render = render

export default script